// client/src/pages/Terms.js
import React, { useEffect } from 'react';
import termsText from '../components/TermsText';
import GradientButton from '../components/GradientButton';

const Terms = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial', maxWidth: '1000px', margin: '0 auto' }}>
      <h2>Terms and Conditions</h2>
      <div style={{ 
        whiteSpace: 'pre-line', 
        lineHeight: '1.6', 
        fontSize: '14px',
        marginBottom: '2rem'
      }}>
        {termsText}
      </div>

      {/* Back to Homepage Button */}
<div style={{ textAlign: 'center', padding: '1rem' }}>
        <GradientButton
          variant="blue"
          onClick={() => window.location.href = '/'}
        >
          ← Back to Home
        </GradientButton>
      </div>
    </div>
  );
};

export default Terms;